import React from 'react';
const Spinner = () =>
    (
        <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
    );


export default Spinner;